"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSummary = void 0;
exports.AccountTray = AccountTray;
exports.NavLabel = exports.AccountTrayContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _core = require("@linaria/core");
var _authedAccountTray = require("./authed-account-tray");
var _unauthedAccountTray = require("./unauthed-account-tray");
var _primaryNavContext = require("../primary-nav-context.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AccountTrayContainer = exports.AccountTrayContainer = /*#__PURE__*/(0, _react2.styled)("details")({
  name: "AccountTrayContainer",
  class: "pl-a1eu3whk"
});
const AccountSummary = exports.AccountSummary = /*#__PURE__*/(0, _react2.styled)("summary")({
  name: "AccountSummary",
  class: "pl-auov0k0"
});
const NavLabel = exports.NavLabel = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "NavLabel",
  class: "pl-n1vedav7"
});
const UserIcon = "pl-uqjp5ca";
function closeTray(accountTrayRef) {
  accountTrayRef.current.removeAttribute('open');
}

/**
 * Account Tray component.
 *
 * @param {Object} props React props
 * @param {string} props.parentLabel Header Label (When authenticated this should be display name)
 * @param {string} props.signInHeading Sign in heading
 * @param {string} props.signInContent Sign in content
 * @param {string} props.signInLabel Sign in label
 * @param {string} props.createAccountHeading Create account heading
 * @param {string} props.createAccountContent Create account content
 * @param {string} props.createAccountLabel Create account label
 * @param {string} props.customerNumberLabel Customer number label
 * @param {string} props.customerUsernameLabel Customer username label
 * @param {string} props.pinLabel Pin label
 * @param {string} props.viewPinLabel View pin label
 * @param {string} props.rewardPointsLabel Reward points label
 * @param {string} props.rewardPoints Reward points
 * @param {string} props.signOutLabel Sign out label
 * @param {string} props.ssoUrlPath SSO Url Path
 * @param {string} props.ssoUrlApp SSO Url App
 * @param {string} props.ssoUrlRealm SSO Url Realm
 * @param {string} props.ssoUrl SSO Url
 * @param {string} props.displayName Display name
 * @param {string} props.accountUrl Account Url
 * @param {string} props.shopperId Shopper ID
 * @param {string} props.vipAccountExecLabel VIP Account ExecLabel
 * @param {string} props.vipEmail Vip Email
 * @param {string} props.vipName Vip Name
 * @param {string} props.vipPhone Vip Phone
 * @param {boolean} props.isVip Is Vip
 * @param {boolean} props.isPro Is Pro
 * @param {string} props.callLabel Call Label
 * @param {string} props.emailLabel Email Label
 * @param {object} props.unauthedMenu Menus with links
 * @param {object} props.authedMenu Menus with links
 * @param {string} props.ssoHost Menus with links
 * @param {string} props.accountHost Menus with links
 * @param {string} props.customerRes Customer Response
 * @param {string} props.infoRes Info Response
 * @param {string} props.unauthedAriaLabel unauthedAriaLabel
 * @param {string} props.authedAriaLabel authedAriaLabel
 *
 * @returns {React.ReactElement} Account Tray
 * @public
 */
function AccountTray({
  id,
  parentLabel,
  unauthedAriaLabel = 'Account Tray',
  authedAriaLabel = 'Account Tray',
  signInHeading,
  signInContent,
  signInLabel,
  createAccountHeading,
  createAccountContent,
  createAccountLabel,
  customerNumberLabel,
  customerUsernameLabel,
  pinLabel,
  viewPinLabel,
  rewardPointsLabel,
  signOutLabel,
  ssoUrlPath,
  ssoUrlApp,
  ssoUrlRealm,
  vipAccountExecLabel,
  callLabel,
  emailLabel,
  unauthedMenu,
  authedMenu,
  ssoHost,
  accountHost,
  accountProductsUrl,
  customerRes,
  infoResponse,
  invert
}) {
  const {
    isLoggedIn
  } = (0, _react.useContext)(_primaryNavContext.PrimaryNavContext);
  const accountTrayRef = (0, _react.useRef)(null);
  const handleClick = ({
    target
  }) => {
    if (accountTrayRef.current.contains(target)) {
      return;
    }
    closeTray(accountTrayRef);
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', handleClick);
      return () => {
        document.removeEventListener('mousedown', handleClick);
      };
    }
  }, []);

  // eslint-disable-next-line complexity
  function getDisplayName(short, info) {
    const INVERSED_NAME_MARKETS = ['ja-JP', 'ko-KR', 'vi-VN', 'zh-SG', 'zh-TW', 'zh-HK'];
    const marketMatch = document.cookie.match('market=([^;]*)(;|$)');
    const auth = info.auth;
    const shopperCookie = info.del ? info[auth] : info;
    const {
      firstname,
      lastname,
      name,
      username,
      loginname,
      shopperId: cookieShopperId
    } = shopperCookie;
    const fallback = name || username || loginname || cookieShopperId || '';
    const market = marketMatch ? marketMatch[1] : '';
    if (short) {
      // vi-VN is a last-name-first market but uses first name as the short display name
      if (market === 'vi-VN') {
        return firstname || fallback;
      }
      return (~INVERSED_NAME_MARKETS.indexOf(market) ? lastname : firstname) || fallback;
    } else if (firstname) {
      return ~INVERSED_NAME_MARKETS.indexOf(market) ? [lastname, firstname].filter(Boolean).join(' ').trim() : [firstname, lastname].filter(Boolean).join(' ').trim();
    }
    return fallback;
  }
  let shortDisplayName = '';
  let displayName = '';
  if (isLoggedIn && infoResponse) {
    shortDisplayName = getDisplayName(true, infoResponse);
    displayName = getDisplayName(false, infoResponse);
  }
  const childTray = isLoggedIn ? /*#__PURE__*/_react.default.createElement(_authedAccountTray.Authed, {
    customerNumberLabel: customerNumberLabel,
    customerUsernameLabel: customerUsernameLabel,
    pinLabel: pinLabel,
    viewPinLabel: viewPinLabel,
    rewardPointsLabel: rewardPointsLabel,
    signOutLabel: signOutLabel,
    ssoUrl: ssoHost,
    accountUrl: accountHost,
    vipAccountExecLabel: vipAccountExecLabel,
    callLabel: callLabel,
    emailLabel: emailLabel,
    closeTray: closeTray,
    accountTrayRef: accountTrayRef,
    menus: authedMenu,
    displayName: displayName,
    customerRes: customerRes,
    infoResponse: infoResponse,
    accountProductsUrl: accountProductsUrl
  }) : /*#__PURE__*/_react.default.createElement(_unauthedAccountTray.Unauthed, {
    signInHeading: signInHeading,
    signInContent: signInContent,
    signInLabel: signInLabel,
    createAccountContent: createAccountContent,
    createAccountHeading: createAccountHeading,
    createAccountLabel: createAccountLabel,
    ssoUrl: ssoHost,
    ssoUrlApp: ssoUrlApp,
    ssoUrlPath: ssoUrlPath,
    ssoUrlRealm: ssoUrlRealm,
    closeTray: closeTray,
    accountTrayRef: accountTrayRef,
    menus: unauthedMenu
  });
  return /*#__PURE__*/_react.default.createElement(AccountTrayContainer, {
    id: `id-${id}`,
    ref: accountTrayRef,
    "data-cy": "account-tray"
  }, /*#__PURE__*/_react.default.createElement(AccountSummary, (0, _extends2.default)({
    className: invert && 'inverted',
    "aria-label": isLoggedIn ? authedAriaLabel : unauthedAriaLabel
  }, _patternLibraryUtils.tracking.create('dropdown_button', true, false)), /*#__PURE__*/_react.default.createElement(NavLabel, null, shortDisplayName || parentLabel, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  })), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "user",
    className: UserIcon,
    fill: _intents.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-partial": "light1"
  }, childTray));
}
AccountTray.propTypes = {
  id: _propTypes.default.string,
  parentLabel: _propTypes.default.string,
  signInHeading: _propTypes.default.string,
  signInContent: _propTypes.default.string,
  signInLabel: _propTypes.default.string,
  createAccountHeading: _propTypes.default.string,
  createAccountContent: _propTypes.default.string,
  createAccountLabel: _propTypes.default.string,
  customerNumberLabel: _propTypes.default.string,
  customerUsernameLabel: _propTypes.default.string,
  pinLabel: _propTypes.default.string,
  viewPinLabel: _propTypes.default.string,
  rewardPointsLabel: _propTypes.default.string,
  signOutLabel: _propTypes.default.string,
  ssoUrl: _propTypes.default.string,
  ssoUrlPath: _propTypes.default.string,
  ssoUrlApp: _propTypes.default.string,
  ssoUrlRealm: _propTypes.default.string,
  accountUrl: _propTypes.default.string,
  isLoggedIn: _propTypes.default.bool,
  vipAccountExecLabel: _propTypes.default.string,
  callLabel: _propTypes.default.string,
  emailLabel: _propTypes.default.string,
  authedMenu: _propTypes.default.arrayOf(_propTypes.default.shape({
    menuTitle: _propTypes.default.string,
    menuItmes: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      href: _propTypes.default.string
    }))
  })),
  unauthedMenu: _propTypes.default.arrayOf(_propTypes.default.shape({
    menuTitle: _propTypes.default.string,
    menuItmes: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      href: _propTypes.default.string
    }))
  })),
  ssoHost: _propTypes.default.string,
  accountHost: _propTypes.default.string,
  accountProductsUrl: _propTypes.default.string,
  customerRes: _propTypes.default.object,
  infoResponse: _propTypes.default.object,
  unauthedAriaLabel: _propTypes.default.string,
  authedAriaLabel: _propTypes.default.string,
  invert: _propTypes.default.bool
};